import api from "./client";

export default {
    getPaymentData() {
        return api.get('/payment/getData');
    },
    addToCart(uid) {
        return api.post('/payment/addToCart', typeof uid === 'object' ? uid : {uid: uid});
    },
    getCart() {
        return api.get('/payment/getCart');
    },
    removeCartItem(uid) {
        return api.post('/payment/removeCartItem', {uid: uid});
    },
    makePayment(data) {
        return api.post('/payment/makePayment', data);
    },
    getTransactions(user_id,page = 1) {
        return api.post('/payment/getTransactions?page=' + page,{user_id:user_id});
    }
}

